@if (form; as form) {
  <form [formGroup]='form' autocomplete='off' novalidate>
    <fieldset>
      <div class='row'>
        <div class='col-12'>
          <legend>{{ label }}</legend>
        </div>
      </div>
      <br>
      <div class='row'>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"startDate" as controlName'>
            <label [for]='controlName'>
              Data od *
            </label>
            <app-date-picker (change)="form.startDateChange($event)" [id]='controlName' [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"endDate" as controlName'>
            <label [for]='controlName'>
              Data do *
            </label>
            <app-date-picker (change)="form.endDateChange($event)" [id]='controlName' [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors fieldLabel='Data od' secondFieldLabel='dacie do' [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-md-4">
          <div class='form-group' *ngIf='"dayQuantity" as controlName'>
            <label [for]='controlName'>
              Ilość dni
            </label>
            <input
              readonly
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu ilość dni'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <fieldset>
            <legend>
              Dane reklamy
            </legend>
            <div class="row">
              <div class="col-md-4">
                <div class='form-group' *ngIf='"adType" as controlName'>
                  <label [for]='controlName'>Typ reklamy *</label>
                  <select
                    (change)="form.calcAdArea()"
                    [ngClass]='{ "is-invalid": form.showError(controlName) }'
                    [id]='controlName'
                    [formControlName]='controlName'>
                    <option value=''>Wybierz</option>
                    <option value='Jednostronna'>Jednostronna</option>
                    <option value='Dwustronna'>Dwustronna</option>
                  </select>
                  <app-validation-errors [control]='form.get(controlName)'>
                  </app-validation-errors>
                </div>
              </div>
            </div>
            <div class="row">
              <div class='col-md-3'>
                <div class='form-group' *ngIf='"adWidth" as controlName'>
                  <label [for]='controlName'>
                    <br>
                    Wysokość reklamy (m) *
                  </label>
                  <input
                    (change)="form.calcAdArea()"
                    mask='separator.2'
                    decimalMarker=','
                    [dropSpecialCharacters]='false'
                    [id]='controlName'
                    [ngClass]='{ "is-invalid": form.showError(controlName) }'
                    [formControlName]='controlName'
                    placeholder='Wpisz tu szerokość reklamy'
                    type='text'>
                  <app-validation-errors [control]='form.get(controlName)'>
                  </app-validation-errors>
                </div>
              </div>
              <div class='col-md-3'>
                <div class='form-group' *ngIf='"adLength" as controlName'>
                  <label [for]='controlName'>
                    <br>
                    Długość reklamy (m) *
                  </label>
                  <input
                    (change)="form.calcAdArea()"
                    mask='separator.2'
                    decimalMarker=','
                    [dropSpecialCharacters]='false'
                    [id]='controlName'
                    [ngClass]='{ "is-invalid": form.showError(controlName) }'
                    [formControlName]='controlName'
                    placeholder='Wpisz tu długość reklamy'
                    type='text'>
                  <app-validation-errors [control]='form.get(controlName)'>
                  </app-validation-errors>
                </div>
              </div>
              <div class='col-md-3'>
                <div class='form-group' *ngIf='"adQuantity" as controlName'>
                  <label [for]='controlName'>
                    <br>
                    Ilość (szt) *
                  </label>
                  <input
                    (change)="form.calcAdArea()"
                    mask='0*'
                    [id]='controlName'
                    [ngClass]='{ "is-invalid": form.showError(controlName) }'
                    [formControlName]='controlName'
                    placeholder='Wpisz tu ilość'
                    type='text'>
                  <app-validation-errors [control]='form.get(controlName)'>
                  </app-validation-errors>
                </div>
              </div>
              <div class='col-md-3'>
                <div class='form-group' *ngIf='"adArea" as controlName'>
                  <label [for]='controlName'>
                    Łączna powierzchnia <br> reklamy (m<sup>2</sup>)
                  </label>
                  <input
                    readonly
                    mask='separator.2'
                    decimalMarker=','
                    [dropSpecialCharacters]='false'
                    [id]='controlName'
                    [ngClass]='{ "is-invalid": form.showError(controlName) }'
                    [formControlName]='controlName'
                    placeholder='Łączna powierzchnia reklamy'
                    type='text'>
                  <app-validation-errors [control]='form.get(controlName)'>
                  </app-validation-errors>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <fieldset>
            <legend>
              Działki
            </legend>
            <div class="row">
              <div class="col-12">
                <app-parcels-crud formControlName="parcels"></app-parcels-crud>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <app-exposed-map-control [control]="form.geometry">
      </app-exposed-map-control>
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-0 mt-3">
            <div class="custom-radio custom-inline">
              <input (change)="form.provideRoadNumberAndNameChange(true)" name="provideRoadNumberAndName"
                     formControlName="provideRoadNumberAndName" type="radio"
                     id="provideRoadNumberAndNameTrue" [value]="true">
              <label for="provideRoadNumberAndNameTrue">
                Chcę wprowadzić numer i nazwę drogi
              </label>
            </div>
            <div class="custom-radio custom-inline">
              <input (change)="form.provideRoadNumberAndNameChange(false)" name="provideRoadNumberAndName"
                     formControlName="provideRoadNumberAndName" type="radio"
                     id="provideRoadNumberAndNameFalse" [value]="false">
              <label for="provideRoadNumberAndNameFalse">
                Chcę wprowadzić ulicę
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class='row'>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"city" as controlName'>
            <label [for]='controlName'>
              Miejscowość *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              (change)="form.cityChange()"
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @if (form.provideRoadNumberAndName.value) {
                @for (item of townWithRoadsList(); track $index) {
                  <option [value]='item.name'>{{ item.name }}</option>
                }
              } @else {
                @for (item of townWithStreetsList(); track $index) {
                  <option [value]='item.name'>{{ item.name }}</option>
                }
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        @if (form.roadNumber) {
          <div class='col-md-3'>
            <div class='form-group' *ngIf='"roadNumber" as controlName'>
              <label [for]='controlName'>
                Numer drogi *
              </label>
              <select
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                (change)="roadNumberChange(form.getElement($event).value)"
                [formControlName]='controlName'>
                <option value=''>Wybierz</option>
                @for (item of getRoadList(form.city.value); track $index) {
                  <option [value]='item.roadNumber'>{{ item.roadNumber }}</option>
                }
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.roadName) {
          <div class='col-md-5'>
            <div class='form-group' *ngIf='"roadName" as controlName'>
              <label [for]='controlName'>
                Nazwa drogi *
              </label>
              <input
                readonly
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu nazwę drogi'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.street) {
          <div class='col-md-6'>
            <div class='form-group' *ngIf='"street" as controlName'>
              <label [for]='controlName'>
                Ulica *
              </label>
              <select
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'>
                <option value=''>Wybierz</option>
                @for (item of getStreetList(form.city.value); track $index) {
                  <option [value]='item.roadNumber + " - " + item.name'>{{ item.roadNumber + " - " + item.name }}
                  </option>
                }
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      </div>
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"adContent" as controlName'>
            <label [for]='controlName'>
              Treść tablicy reklamowej *
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu treść tablicy reklamowej'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
}
